module.exports = __webpack_public_path__ + "static/media/LAZ_02.a4646c1d.jpg";